/**
 * Pick the submit email from the quote-form payload.
 *
 * Each thankYou slide stores the address on a different key (estimateEmail,
 * commercialEmail, personEmail, or email). A missing key is `undefined`, not
 * `null`, so a `!== null` check treats it as present and overwrites a real
 * address collected on another slide with undefined.
 */
export function pickSubmitEmail(data = {}) {
  const candidates = [
    data.estimateEmail,
    data.commercialEmail,
    data.personEmail,
    data.email,
  ];
  for (const value of candidates) {
    if (typeof value === 'string' && value.trim() !== '') {
      return value.trim();
    }
  }
  return '';
}

/**
 * Resolve the submit email from the slide fields, then merge the explicit
 * dataPayload (includes email, quote amount, property details) on top.
 *
 * The order matters: a payload email (for example one corrected on the quote
 * review screen) must still win over a stale slide-specific field such as
 * estimateEmail, as it did before pickSubmitEmail existed.
 */
export function mergeSubmitPayload(formData, dataPayload) {
  const merged = { ...formData };
  const pickedEmail = pickSubmitEmail(merged);
  if (pickedEmail) {
    merged.email = pickedEmail;
  }
  return dataPayload ? { ...merged, ...dataPayload } : merged;
}
